import { render } from "./report.vue?vue&type=template&id=56729138"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"

import "./report.vue?vue&type=style&index=0&id=56729138&lang=scss"
script.render = render

export default script